export default __webpack_public_path__ + "static/media/num-icon2.b2d66edc.svg";